import { useEffect, useRef, useState } from 'react';

export const useGooglePlaces = (inputRef, onPlaceSelected) => {
  const autocompleteRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Verifica se Google Maps API è caricata
    const checkGoogleLoaded = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setIsLoaded(true);
      } else {
        setTimeout(checkGoogleLoaded, 100);
      }
    };

    checkGoogleLoaded();
  }, []);

  useEffect(() => {
    if (isLoaded && inputRef.current && !autocompleteRef.current) {
      // Inizializza l'autocomplete
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          types: ['address'],
          componentRestrictions: { country: 'IT' }, // Limita all'Italia
          fields: ['address_components', 'formatted_address', 'geometry']
        }
      );

      // Listener per quando viene selezionato un indirizzo
      autocompleteRef.current.addListener('place_changed', () => {
        const place = autocompleteRef.current.getPlace();
        
        if (place.address_components) {
          const addressComponents = {};
          
          place.address_components.forEach(component => {
            const componentType = component.types[0];
            
            switch (componentType) {
              case 'street_number':
                addressComponents.streetNumber = component.long_name;
                break;
              case 'route':
                addressComponents.streetName = component.long_name;
                break;
              case 'locality':
                addressComponents.city = component.long_name;
                break;
              case 'administrative_area_level_2':
                addressComponents.province = component.short_name;
                break;
              case 'country':
                addressComponents.country = component.short_name;
                break;
              case 'postal_code':
                addressComponents.postalCode = component.long_name;
                break;
            }
          });

          if (onPlaceSelected) {
            onPlaceSelected({
              formattedAddress: place.formatted_address,
              addressComponents,
              geometry: place.geometry
            });
          }
        }
      });
    }

    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [isLoaded, inputRef, onPlaceSelected]);

  return { isLoaded, autocomplete: autocompleteRef.current };
};